import React from 'react';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useState, useEffect } from 'react';


const formatCurrency = (value) => {
  return parseInt(value || 0).toLocaleString();
};

const generarPDF = async () => {

  const boton = document.getElementById("btn-generar");
  boton.classList.add("hide"); // Ocultar
  await new Promise(resolve => setTimeout(resolve, 2)); // Espera breve para que el DOM se actualice

  const input = document.getElementById("reporte-pdf");

  const pdf = new jsPDF("p", "mm", "letter");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const margin = { top: 20, bottom: 20, left: 10, right: 10 };
  const contentWidth = pdfWidth - margin.left - margin.right;
  const contentHeight = pdfHeight - margin.top - margin.bottom;

  const canvas = await html2canvas(input, {
    scale: 2,
    backgroundColor: '#FFFFFF',
    windowWidth: input.scrollWidth,
    scrollY: -window.scrollY, // Evita desplazamientos
  });

  const imageWidthPx = canvas.width;
  const imageHeightPx = canvas.height;

  // Convertir altura del contenido PDF a pixeles para cortes precisos
  const contentHeightPx = (contentHeight * imageWidthPx) / contentWidth;

  let position = 0;
  let pageNumber = 0;

  while (position < imageHeightPx) {
    const sliceHeight = Math.min(contentHeightPx, imageHeightPx - position);

    // Crear canvas temporal con el slice visible
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = imageWidthPx;
    pageCanvas.height = sliceHeight;

    const ctx = pageCanvas.getContext("2d");

    ctx.drawImage(
      canvas,
      0, position,
      imageWidthPx, sliceHeight,
      0, 0,
      imageWidthPx, sliceHeight
    );

    const imgData = pageCanvas.toDataURL("image/png");

    if (pageNumber > 0) pdf.addPage();

    pdf.addImage(
      imgData,
      'PNG',
      margin.left,
      margin.top,
      contentWidth,
      (sliceHeight * contentWidth) / imageWidthPx
    );

    position += sliceHeight;
    pageNumber++;
  }

  const totalPages = pageNumber;

  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(9);
    pdf.setTextColor(100);

    pdf.text(
      `Generado: ${new Date().toLocaleString("es-CL")}`,
      margin.left,
      10
    );

    const footerY = pdfHeight - 12;
    pdf.text(
      `© ${new Date().getFullYear()} - propiedata.cl | contacto@propiedata.cl`,
      pdfWidth / 2,
      footerY,
      { align: 'center' }
    );
    pdf.text(
      `Página ${i} de ${totalPages}`,
      pdfWidth / 2,
      footerY + 6,
      { align: 'center' }
    );
  }

  pdf.save("reporte_final.pdf");

  boton.classList.remove("hide"); // Volver a mostrar

};






const Reporte = ({ resultado, construcciones, construccionesAgr }) => {
  if (!resultado) return null; // Si no hay resultado, no mostrar nada

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isMobile, setIsMobile] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const agruparPorDestino = (construcciones) => {
    return construcciones.reduce((grupos, construccion) => {
      const destino = construccion.destino || "Obras complementarias";
      if (!grupos[destino]) {
        grupos[destino] = [];
      }
      grupos[destino].push(construccion);
      return grupos;
    }, {});
    };


    const agruparPorDestinoAgr = (construccionesAgr) => {
      console.log("agrupar",construccionesAgr)
    return construccionesAgr.reduce((gruposArg, construccionAgr) => {
      const destino = construccionAgr.destino || "Tipos de suelo";
      if (!gruposArg[destino]) {
        gruposArg[destino] = [];
      }
      gruposArg[destino].push(construccionAgr);
      return gruposArg;
    }, {});
    };

  const gruposDestinos = agruparPorDestino(construcciones);
  const gruposDestinosAgr = agruparPorDestinoAgr(construccionesAgr);


  return (

      <div id="reporte-pdf" className="reporte-container" style={{
      padding: isMobile ? '90px 15px 15px' : '60px 15px 15px'
    }}>
        <div className="reporte">

          <button id="btn-generar" onClick={generarPDF} className="pdf-button" style={{
        position: isMobile ? 'static' : 'absolute',
        width: isMobile ? '100%' : 'auto'
      }}>
            Descargar PDF</button>


          <h2>{resultado.direccion?.trim()}</h2>
          <div className="reporte-datos">
            <div className="columna-izquierda">
              <p><strong>Comuna:</strong> {resultado.comuna || 'N/A'}</p>
              <p><strong>Rol:</strong> {resultado.rol || 'N/A'}</p>
              <p><strong>Destino:</strong> {resultado.destino || 'N/A'}</p>
              <p><strong>Ubicación:</strong> {resultado.ubicacion || 'N/A'}</p>
              <p><strong>Superficie del
                Terreno:</strong> {(resultado.agricola === 1) ? ((parseFloat(resultado.sup_terreno) / 10000).toLocaleString('es-CL', {minimumFractionDigits: 2, maxiummFractionDigits: 2})) : parseFloat(resultado.sup_terreno).toLocaleString('es-CL')} {(resultado.agricola === 1) ? "Ha" : "m²"}
              </p>
            </div>
            <div className="columna-derecha">
              <p><strong>Avalúo Total:</strong> ${formatCurrency(resultado.avaluo_total)}</p>
              <p><strong>Avalúo Exento:</strong> ${formatCurrency(resultado.avaluo_exento)}</p>
              <p><strong>Avalúo Afecto:</strong> ${formatCurrency(resultado.avaluo_total - resultado.avaluo_exento)}</p>
              <p><strong>Contribuciones Trimestrales:</strong> ${formatCurrency(resultado.contribuciones)}</p>
            </div>
          </div>
          {construcciones.length > 0 && (
              <div className="grupos-destinos">
                {Object.entries(gruposDestinos).map(([destino, construcciones]) => {

                  const materialVolumetrico = ["OB", "SA", "SB", "EA", "EB", "W "];

                  const sumaSuperficies = construcciones.reduce((sum, construccion) => {
                    // Verificar si el código del material NO está en la lista materialVolumetrico
                    if (!materialVolumetrico.includes(construccion.cod_material)) {
                      return sum + (parseFloat(construccion.sup_construccion) || 0);
                    }
                    // Si el código del material está en la lista, no sumar
                    return sum;
                  }, 0);

                  return (
                      <div key={destino} className="grupo-destino">
                        <h4>
                          {destino} <span>({Math.round(sumaSuperficies).toLocaleString('es-CL')} m²)</span>
                        </h4>
                        <div className="construcciones-grid">
                          {construcciones.map((construccion, index) => (
                              <div key={index} className="construccion">
                                {construccion.material && <p><strong>Material:</strong> {construccion.material}</p>}
                                {construccion.calidad && <p><strong>Calidad:</strong> {construccion.calidad}</p>}
                                {construccion.sup_construccion && <p>
                                  <strong>{materialVolumetrico.includes(construccion.cod_material) ? "Volumen" : "Superficie"}:</strong> {Math.round(construccion.sup_construccion).toLocaleString('es-CL')} {materialVolumetrico.includes(construccion.cod_material) ? "m³" : "m²"}
                                </p>}
                                {construccion.año && construccion.año !== "0000" &&
                                    <p><strong>Año de Construcción:</strong> {construccion.año}</p>}
                                {construccion.condicion_especial &&
                                    <p><strong>Condición Especial:</strong> {construccion.condicion_especial}</p>}

                              </div>
                          ))}
                        </div>
                      </div>
                  );
                })}
              </div>

          )}
          {Array.isArray(construccionesAgr) && construccionesAgr.length > 0 && (
              <div className="grupos-destinos">
                {Object.entries(gruposDestinosAgr).map(([destino, construccionesArg]) => {

                  const materialVolumetrico = ["OB", "SA", "SB", "EA", "EB", "W "];

                  const sumaSuperficiesArg = construccionesArg.reduce((sum, construccionesArg) => {
                    // Verificar si el código del material NO está en la lista materialVolumetrico
                    if (!materialVolumetrico.includes(construccionesArg.cod_material)) {
                      return sum + (parseFloat(construccionesArg.sup_construccion) || 0);
                    }
                    // Si el código del material está en la lista, no sumar
                    return sum;
                  }, 0);


                  const sumaSuperficiesSuelo = construccionesArg.reduce((sum, construccion) => {
                    // Verificar si el código del material NO está en la lista materialVolumetrico
                    if (construccion.cod_material === null) {
                      return sum + (parseFloat(construccion.sup_suelo) / 100 || 0);
                    }
                    // Si el código del material está en la lista, no sumar
                    return sum;
                  }, 0);


                  return (
                      <div key={destino} className="grupo-destino">
                        <h4>
                          {destino}
                          <span> ({destino === "Tipos de suelo" ? `${sumaSuperficiesSuelo.toLocaleString('es-CL',{minimumFractionDigits:2, maximumFractionDigits:2})} Ha` : `${Math.round(sumaSuperficiesArg).toLocaleString('es-CL')} m²`})</span>
                        </h4>
                        <div className="construcciones-grid">
                          {construccionesArg.map((construccionesArg, index) => (
                              <div key={index} className="construccion">
                                {construccionesArg.tipo_suelo && <p><strong>Tipo
                                  Suelo:</strong> Clase {construccionesArg.cod_suelo} {construccionesArg.tipo_suelo}
                                </p>}
                                {construccionesArg.sup_suelo > 0 && (<p><strong>Superficie
                                  Suelo:</strong> {(construccionesArg.sup_suelo / 100).toLocaleString('es-CL',{minimumFractionDigits: 2, maximumFractionDigits: 2})} Ha</p>)}
                                {construccionesArg.material &&
                                    <p><strong>Material:</strong> {construccionesArg.material}</p>}
                                {construccionesArg.calidad &&
                                    <p><strong>Calidad:</strong> {construccionesArg.calidad}</p>}
                                {construccionesArg.sup_construccion > 0 && (<p>
                                  <strong>{materialVolumetrico.includes(construccionesArg.cod_material) ? "Volumen" : "Superficie"}:</strong> {Math.round(construccionesArg.sup_construccion).toLocaleString('es-CL')} {materialVolumetrico.includes(construccionesArg.cod_material) ? "m³" : "m²"}
                                </p>)}

                              </div>
                          ))}
                        </div>
                      </div>
                  );
                })}
              </div>

          )}

          <div className="advertencia-reporte" style={{
            marginTop: '15px',
            padding: '8px',
            backgroundColor: '#fff8e1',
            //borderLeft: '4px solid #ffc107',
            fontSize: '0.9em',
            color: '#5d4037'
          }}>
            <p><strong>Advertencia:</strong> Los datos presentados podrían estar desactualizados.
              La propiedad consultada podría tener edificaciones no regularizadas que no se reflejan en este reporte.
            </p>
          </div>
        </div>

      </div>


  );
};

export default Reporte;